import { render, staticRenderFns } from "./PersonScopePickerDialog.vue?vue&type=template&id=3e515d5a&scoped=true"
import script from "./PersonScopePickerDialog.vue?vue&type=script&lang=js"
export * from "./PersonScopePickerDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonScopePickerDialog.vue?vue&type=style&index=0&id=3e515d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e515d5a",
  null
  
)

export default component.exports